"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Transition = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Transition = exports.Transition = /*#__PURE__*/function (_Component) {
  _inherits(Transition, _Component);
  function Transition() {
    var _this;
    _classCallCheck(this, Transition);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Transition, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      entering: false,
      mounted: false
    });
    _defineProperty(_assertThisInitialized(_this), "timer", null);
    _defineProperty(_assertThisInitialized(_this), "timestamp", 0);
    _defineProperty(_assertThisInitialized(_this), "prevTimeout", 0);
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var _this$props = _this.props,
        enter = _this$props.enter,
        timeout = _this$props.timeout;
      _this.prevTimeout = timeout;
      enter && _this.enter();
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      return _this.stopTimer();
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (_ref) {
      var prevEnter = _ref.enter;
      var enter = _this.props.enter;
      enter != prevEnter && (enter ? _this.enter() : _this.exit());
    });
    _defineProperty(_assertThisInitialized(_this), "enter", function () {
      _this.setState({
        entering: true,
        mounted: true
      });
      _this.startTimer(null);
    });
    _defineProperty(_assertThisInitialized(_this), "exit", function () {
      return _this.setState({
        entering: false
      }, function () {
        return _this.startTimer(_this.exited);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "exited", function () {
      return _this.setState({
        mounted: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "startTimer", function (timer) {
      var timeout = _this.props.timeout;
      var delta = _this.prevTimeout - (Date.now() - _this.timestamp);
      if (delta < 0) {
        delta = 0;
      }
      var newTimeout = timeout - delta;
      _this.prevTimeout = newTimeout !== timeout ? newTimeout : timeout;
      _this.timestamp = Date.now();
      clearTimeout(_this.timer);
      _this.timer = setTimeout(timer, newTimeout);
    });
    _defineProperty(_assertThisInitialized(_this), "stopTimer", function () {
      clearTimeout(_this.timer);
      _this.timer = null;
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props2 = _this.props,
        children = _this$props2.children,
        enter = _this$props2.enter;
      var _this$state = _this.state,
        entering = _this$state.entering,
        mounted = _this$state.mounted;
      return (enter || mounted) && children(entering);
    });
    return _this;
  }
  return _createClass(Transition);
}(_react.Component);